import { createFileRoute, redirect } from '@tanstack/react-router';
import { documentTypesQueryOptions } from '@/hooks/useDocumentsQuery';
import { ensurePermissions } from '@/hooks/usePermissions';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute('/(client)/documents/(pages)')({
  // Layout route for every documents screen, so the read permission is asked
  // once here rather than on each child route.
  beforeLoad: async ({ location }) => {
    const perms = await ensurePermissions();
    if (!perms.documents.canRead) {
      throw redirect({ to: '/dashboard' });
    }

    if (
      location.pathname === '/documents' ||
      location.pathname === '/documents/'
    ) {
      throw redirect({ to: '/documents/my-documents' });
    }
  },
  // Pre-fetch document types once for the whole documents section
  loader: () => queryClient.ensureQueryData(documentTypesQueryOptions()),
});
